import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Category } from '../../../../models/ws-common/category.model';
import { ApiResponse } from '../../../../models/api-response.model';


const URL_CATEGORY = `${environment.common}/category`;

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private http: HttpClient) { }

  getCategory(): Observable<ApiResponse<Category[]>>{
    return this.http.get<ApiResponse<Category[]>>(`${URL_CATEGORY}/?PageSize=0`, { withCredentials: true });
  }

  getCategoryById(id: string): Observable<any> {
    return this.http.get<ApiResponse<Category>>(`${URL_CATEGORY}/${id}`, { withCredentials: true });
  }

  getSubcategory(): Observable<ApiResponse<Category[]>> {
    return this.http.get<ApiResponse<Category[]>>(`${URL_CATEGORY}/subcategory/?PageSize=0`, { withCredentials: true });
  }

  getSubcategoryProductRelated(): Observable<ApiResponse<Category[]>> {
    return this.http.get<ApiResponse<Category[]>>(`${URL_CATEGORY}/subcategory/product/?PageSize=0`, { withCredentials: true });
  }

  getSubcategoryAllRelated(): Observable<ApiResponse<Category[]>> {
    return this.http.get<ApiResponse<Category[]>>(`${URL_CATEGORY}/subcategory/all/?PageSize=0`, { withCredentials: true });
  }

  getCategoryProductRelated(): Observable<ApiResponse<Category[]>> {
    return this.http.get<ApiResponse<Category[]>>(`${URL_CATEGORY}/product/?PageSize=0`, { withCredentials: true });
  }

  getSubcategoryByIdProductRelated(id: string): Observable<any> {
    return this.http.get<any>(`${URL_CATEGORY}/${id}/subcategory/product/?PageSize=0`, { withCredentials: true });
  }
}
